import * as React from 'react';
import { Link } from 'react-router-dom';

import { NavDrawer, NavDrawerButton } from '@App/bundles/common/components'

import './masterHeader.css'

export interface IMasterHeaderState {
  isDrawerOpen: boolean
}

export default class MasterHeader extends React.Component<any, IMasterHeaderState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isDrawerOpen: false
    }
  }

  public toggleDrawer = () => {
    console.log('toggle');
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen
    })
  }

  public render() {
    return (
      <header className='master_header'>
      <div className='logo-container'>
        <div className='master_logo' />
      </div>
        <div className='master_navbutton'>
          <NavDrawerButton ToggleButton={this.toggleDrawer}/>
        </div>

        <div className='master_navdrawer'>
          <NavDrawer isNavBarVisible={this.state.isDrawerOpen} toggleDrawer={ this.toggleDrawer }/>
        </div>

        <div className="tbar_nav">
              <ul>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                <li>
                  <Link to='/photos/events'>Events</Link>
                </li>
                <li>
                  <Link to='/photos/lifestyle'>Lifestyle</Link>
                </li>
                <li>
                  <Link to='/photos/portraits'>Portraits</Link>
                </li>
                <li>
                  <Link to='/photos/published'>Published</Link>
                </li>
                <li>
                  <Link to='/profile'>Profile</Link>
                </li>
              </ul>
            </div>

      </header>
    );
  }
}


        {/* Nav Drawer */}
        {/* <nav className={this.isDrawerVisible()}>
          <ul>
            <li className='firstli'/>
            <li className='otherli'>
              <Link to='/photos/events'>Events</Link>
            </li>
            <li className='otherli'>
              <Link to='/photos/lifestyle'>Lifestyle</Link>
            </li>
            <li className='otherli'>
              <Link to='/photos/portraits'>Portraits</Link>
            </li>
            <li className='otherli'>
              <Link to='/photos/published'>Published</Link>
            </li>
          </ul>
        </nav> */}

        {/* Full Header */}
            {/* <header className="toolbar">
          <nav className="toolbar__navigation">
            <div className="spacer"/>
            <div className="" onClick={this.props.toggleDrawer}>
              <NavDrawerButton
                ToggleButton={this.props.toggleDrawer}/>
            </div>
            <div className="toolbar__navigation-items">
              <ul>
                <li>
                  <Link to='/'>Home</Link>
                </li>
                <li>
                  <Link to='/photos/events'>Events</Link>
                </li>
                <li>
                  <Link to='/photos/groups'>Groups</Link>
                </li>
                <li>
                  <Link to='/photos/lifestyle'>Lifestyle</Link>
                </li>
                <li>
                  <Link to='/photos/portraits'>Portraits</Link>
                </li>
                <li>
                  <Link to='/photos/published'>Published</Link>
                </li>
              </ul>
            </div>
          </nav>
        </header> */}



// WEBPACK FOOTER //
// ./src/bundles/common/components/masterHeader/masterHeader.tsx